export default __webpack_public_path__ + "static/media/d.751e9023.mp3";